import React from 'react';

import { MainMarketsColumn } from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/MainMarkets/MainMarketColumn';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import {
    MainMarketsColumnTitle,
    MainMarketsTable
} from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/MainMarkets/MainMarkets.style';
import { QuickPickViewState } from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/QuickPickView.state';

import { DateTime } from 'src_common/utils/time/time';
import { MARKET_TYPE } from 'src_common/common/websocket2/models/EventModel';

interface MainMarketsPropsType {
	userId: number,
	quickPickState: QuickPickViewState,
}

export const WinOnly = observer('WinOnly', (props: MainMarketsPropsType) => {
    const appState = useAppStateContext();
    const event = props.quickPickState.getSelectedEvent;
    const competitionId = event?.competition;
    if (event === null || competitionId === undefined) {
        return null;
    }

    const competition = appState.websocketV2.getCompetitionModel(competitionId);

    if (competition === null) {
        return null;
    }

    const startTime = DateTime.from(event.timeSettingsStartTime)?.tz(props.quickPickState.timeFilterState.timezone);

    return (
        <MainMarketsTable>
            <MainMarketsColumnTitle>
                {startTime?.format('HH:mm')}<br />
                <small>{competition.name}</small>
            </MainMarketsColumnTitle>
            {event.markets.map(market => {
                if (market.templateId.includes(MARKET_TYPE.WIN_ONLY)) {
                    return (
                        <MainMarketsColumn
                            key={market.id}
                            userId={props.userId}
                            marketId={market.id}
                            eventId={event.id}
                            quickPickState={props.quickPickState}
                        />
                    );
                }
                return null;
            })}
        </MainMarketsTable>
    );
});
